import { useNavigate } from 'react-router-dom';
import { useSite } from '../data/SiteContext';
import logo from '../assets/images/hola-caribe-logo.svg';

export default function Footer() {
  const navigate = useNavigate();
  const { contact, dests } = useSite();
  // Live destinations, not a hardcoded list — first six alphabetically, then the full catalogue link.
  const footerDests = [...dests].sort((a, b) => a.name.localeCompare(b.name)).slice(0, 6);
  return (
    <footer style={{ background:'linear-gradient(180deg,#0c2b2f,#04222a)', color:'rgba(255,255,255,0.85)', padding:'56px 24px 28px' }}>
      <div style={{ maxWidth:1240, margin:'0 auto', display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(200px,1fr))', gap:36 }}>
        <div>
          <div style={{ marginBottom:14 }}>
            {/* The logo carries the wordmark + tagline itself, so no brand text next to it. */}
            <img src={logo} alt={contact.brand} style={{ height:72, display:'block' }} />
          </div>
          <p style={{ fontSize:14, lineHeight:1.65, maxWidth:280, color:'rgba(255,255,255,0.7)' }}>Boutique travel agency crafting beach, cultural and honeymoon escapes across the world's warmest corners.</p>
        </div>
        <div>
          <div style={{ fontWeight:800, color:'#fff', marginBottom:14, fontSize:14 }}>Destinations</div>
          <div style={{ display:'grid', gap:9, fontSize:14 }}>
            {footerDests.map(d => (
              <span key={d.id} className="footer-link" onClick={() => navigate('/destinations/' + d.slug)}>{d.name}</span>
            ))}
            <span className="footer-link" onClick={() => navigate('/destinations')} style={{ fontWeight:700 }}>All destinations →</span>
          </div>
        </div>
        <div>
          <div style={{ fontWeight:800, color:'#fff', marginBottom:14, fontSize:14 }}>Company</div>
          <div style={{ display:'grid', gap:9, fontSize:14 }}>
            <span className="footer-link" onClick={() => navigate('/tours')}>Tours</span>
            <span className="footer-link" onClick={() => navigate('/guides')}>Travel guides</span>
            <span className="footer-link" onClick={() => navigate('/contact')}>Contact</span>
            <span className="footer-link" onClick={() => navigate('/partners')}>For Travel Professionals</span>
          </div>
        </div>
        <div>
          <div style={{ fontWeight:800, color:'#fff', marginBottom:14, fontSize:14 }}>Get in touch</div>
          <div style={{ display:'grid', gap:9, fontSize:14, color:'rgba(255,255,255,0.8)' }}>
            <a className="footer-link" href={contact.waLink} target="_blank" rel="noreferrer">WhatsApp {contact.phone}</a>
            <a className="footer-link" href={contact.telLink}>Call {contact.phone}</a>
            <a className="footer-link" href={contact.igLink} target="_blank" rel="noreferrer">Instagram @{contact.igHandle}</a>
            <a href={`mailto:${contact.email}`} className="footer-link">{contact.email}</a>
          </div>
        </div>
      </div>
      <div style={{ maxWidth:1240, margin:'36px auto 0', paddingTop:20, borderTop:'1px solid rgba(255,255,255,0.12)', fontSize:13, color:'rgba(255,255,255,0.55)', display:'flex', justifyContent:'space-between', flexWrap:'wrap', gap:10 }}>
        <span>© 2026 {contact.brand} Travel. All rights reserved.</span>
        <span>Privacy · Terms · Booking conditions</span>
      </div>
    </footer>
  );
}
